import { useRouter } from "next/router"
import { SwiperSlide } from "swiper/react"
import { Image, RatioImage } from "@components/anti/Image"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import { translations } from "src/helper/translations"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import { imgUrl } from "src/mixins"

import imgDummy from "../../../../public/img/dummy/img_dummy.jpeg"
import SwiperNavigation from "../SwiperNavigation"

export default function SectionGallery({
  sectionName = "",
  theme = "dark",
  hasTitle = true,
  data,
}) {
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const Router = useRouter()
  return (
    <section className={`sc-gallery ${sectionName}`} ref={trigger}>
      <div className="py-main">
        <div className="container">
          <div className="row-title">
            <h1 className={`title ${anim(1)}`}>
              {hasTitle ? translations[`gallery_${Router.locale}`] : ""}
            </h1>
            <SwiperNavigation
              handleNext={handleNext}
              handlePrev={handlePrev}
              theme={theme}
            />
          </div>
          <SliderSwiper
            swiperRef={swiperRef}
            loop
            breakpoints={{
              365: {
                slidesPerView: 1.1,
                spaceBetween: 15,
              },
              640: {
                slidesPerView: 1.1,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 1.2,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 1.3,
                spaceBetween: 15,
              },
            }}
            className="gallery-slider mt-4"
          >
            {(data?.length ? data : Array(5).fill())?.map((item, i) => (
              <SwiperSlide key={`gallery-item-${i}`}>
                <div className="img_gallery-item-wrapper">
                  {/* <Image
                    //   src="/img/dummy/img_dummy.jpeg"
                    src={data?.length ? imgUrl(item.image) : imgDummy}
                    alt="gallery-item"
                    className={`img-fluid ${anim(i + 2)}`}
                    fill
                    // height={485}
                  /> */}
                  <RatioImage
                    ratio="r-2-1"
                    src={data?.length ? imgUrl(item.image) : imgDummy}
                    alt="gallery-item"
                    className={`img-fluid ${anim(i + 2)}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </SliderSwiper>
        </div>
      </div>
    </section>
  )
}
